export default __webpack_public_path__ + "static/media/group_chat.57e0ebe4.svg";